export default __webpack_public_path__ + "static/media/icone-email2.46bc3d37.svg";